import { useSelector } from 'react-redux'
import { RootState } from '../globalRedux/store'
import { usePathname } from 'next/navigation'
/* 
when Block should occur
1. not an isBeneficiary 
2. isFreeUser
3. not loggedIn
*/

export const useFreeUserValidation = () => {
  const user = useSelector((state: RootState) => state.user)
  const pathName = usePathname()

  const isLoggedIn = (): boolean => {
    return user?.loggedIn ?? false
  }

  const isBeneficiary = (): boolean => {
    return user?.isBeneficiary ?? false
  }

  const isFreeUser = (): boolean => {
    return user?.userSubscription == 'Free'
  }

  const isAdmin = (): boolean => {
    return [
      'fructidor_admin',
      'fructidor_manager',
      'fructidor_editor',
    ]?.includes(user?.userRole)
  }

  const isCompanyTab = (): boolean => {
    return pathName?.split('/')?.includes('company-tab')
  }

  const isProductTab = (): boolean => {
    return pathName?.split('/')?.includes('product-company-tab')
  }

  const blockSearching = () => {
    return user?.skipFetchingFreeUser
  }

  const baseSkipping = (): boolean => {
    return !isLoggedIn() || !isBeneficiary() || isFreeUser()
  }

  const skipCompanyQuery = (): boolean => {
    return !isAdmin() && baseSkipping() && (!isCompanyTab() || blockSearching())
  }

  const skipCompanyProductQuery = (): boolean => {
    return !isAdmin() && baseSkipping() && (!isProductTab() || blockSearching())
  }

  const skipSearchQuery = (searchingPage: string): boolean => {
    return (
      !isAdmin() &&
      baseSkipping() &&
      (blockSearching() ||
        (searchingPage == 'company_name' ? !isCompanyTab() : !isProductTab()))
    )
  }

  const isModalApplicable = (): boolean => {
    return !isAdmin() && baseSkipping()
  }
  const skipRetailQuery = (): boolean => {
    return isModalApplicable() && blockSearching()
  }

  return {
    skipCompanyQuery,
    skipCompanyProductQuery,
    isModalApplicable,
    skipSearchQuery,
    skipRetailQuery,
  }
}
